import { render, staticRenderFns } from "./FormAttributes.vue?vue&type=template&id=80765446"
import script from "./FormAttributes.vue?vue&type=script&lang=js"
export * from "./FormAttributes.vue?vue&type=script&lang=js"
import style0 from "./FormAttributes.vue?vue&type=style&index=0&id=80765446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports